module.exports = __webpack_public_path__ + "static/media/payment.6377513d.png";